const messages = {
  seasons: {
    all: "Toutes saisons",
    summer: "Été",
    winter: "Hiver",
    general: "Général",
  },
  offer:
    "Nous élargissons régulièrement nos offres pour vous !<br /><br />Nous vous informerons des nouvelles formations dans votre boîte de réception.",
  summary: {
    congratulations: "FÉLICITATIONS - VOUS AVEZ TERMINÉ VOTRE FORMATION SUR",
    participation:
      "Vous avez terminé avec succès la formation en ligne Transporter All-Season Tires.",
    certificate:
      "Votre certificat vous sera envoyé par e-mail ou vous pouvez le télécharger directement en PDF ici :",
    send: "Télécharger le certificat",
  },
  online: {
    title: "Nos formations en ligne",
    desc: "Assurez-vous une expertise et, après réussite des tests correspondants, recevez votre certificat personnel de participation ainsi qu'une première prime de 40 points pour le club premium.",
    content:
      "Découvrez dès maintenant nos formations en ligne et participez directement sur la plateforme :",
    categories: {
      title: "Formation en ligne",
      description:
        "Restez en avance grâce au savoir : obtenez une expertise exclusive pour vous et votre équipe avec nos offres de formation. Que ce soit nos formations en ligne auxquelles vous participez directement sur la plateforme, nos cours et séminaires pratiques au Bridgestone Training Center, ou encore des formations externes dont vous pouvez réduire le coût grâce à vos points premium.",
      general: {
        title: "Général",
        subtitle: "Formation en ligne : Général",
        description:
          "Découvrez les dernières technologies, les évolutions importantes de l'industrie du pneu, des conseils pour vos arguments de vente, et bien plus encore.",
        subdesription:
          "Obtenez un savoir-faire expert et, après réussite des tests de chaque formation, votre certificat personnel de participation ainsi qu'un bonus unique de 40 points pour le club premium.",
      },
      product: {
        title: "Produits",
        subtitle: "Formation en ligne : Produits",
        description:
          "Approfondissez votre expertise produits Bridgestone et Firestone pour des ventes réussies grâce à nos vidéos de formation concises.",
        subdesription:
          "Obtenez un savoir-faire expert et, après réussite des tests de chaque formation, votre certificat personnel de participation ainsi qu'un bonus unique de 40 points pour le club premium.",
      },
    },
  },
  lectures: {
    title: "Formations Bridgestone",
    desc: "Développez votre expertise et réservez nos formations et stages intensifs pour vous et votre équipe. Vous pouvez participer aux formations au Bridgestone Competence and Training Center à Dietzenbach (près de Francfort-sur-le-Main) ou, pour certaines formations, les faire organiser dans votre entreprise. Vous pouvez utiliser vos points bonus pour ces formations et ainsi en compenser totalement ou partiellement le coût.",
    content: "Découvrez dès maintenant nos formations actuelles et demandez une réservation :",
  },
  singleLecture: {
    registerForm: {
      title: "Contenu de la formation",
      inquiry: "Demande",
      interested: "Je suis intéressé par la formation",
      participantsNr: "Nombre de participants",
      pointsFromBalance: "Je souhaite utiliser des points de mon solde.",
      reduction: "Cela correspond à une réduction de coût de {points} euros.",
      request: "Envoyer la demande",
    },
    success: {
      thanks: "Merci",
      title: "Votre demande a été envoyée à l'équipe formation.",
      feedbackTime:
        "Vous recevrez une réponse sous 14 jours pour clarifier tous les détails.",
      points:
        "Les points bonus utilisés à hauteur de<br /><strong>{points}</strong> points ont été déduits de votre<br />compte de points.",
      refund:
        "Si la formation n'a pas lieu, les points vous seront bien sûr recrédités.",
      queries: "Pour toute question, veuillez contacter :",
    },
    index: {
      costs: "Coûts et informations de participation",
      duration: "Durée : {duration}",
      cost: "Coût {cost} : {price} euros",
      participantsNr: "Participants : min. {min} - max. {max} personnes",
    },
  },
  index: {
    title: "Formations",
    desc: "Un avantage par le savoir : obtenez des connaissances spécialisées exclusives pour vous et votre équipe grâce à nos offres de formation. Qu'il s'agisse de nos formations en ligne auxquelles vous pouvez participer directement sur la plateforme, de nos séminaires pratiques au centre de formation Bridgestone ou de formations externes dont vous pouvez réduire le coût avec vos points de récompense.",
    online: {
      title: "Formations en ligne",
      desc: "Participez directement sur la plateforme et obtenez {points} points pour le club premium.",
    },
    lectures: {
      title: "Formations",
      desc: "Formations de haute qualité dans notre centre de formation ou sur votre site.",
    },
    external: {
      title: "Formations externes",
      desc: "Utilisez vos points bonus pour des offres de prestataires tiers et réduisez les coûts.",
    },
  },
  single: {
    done: "Formation terminee.",
    doneDownloadCertificate: "Formation terminee. Telecharger le certificat.",
  },
  certificate: {
    header: "CERTIFICAT",
    atCourse: "a participé avec succès à la formation",
    takePart: "cours.",
    contains: "COMPOSANTES DU COURS",
    country: "France",
  },
};

export default {
  messages,
};
